const LOG_STORAGE_KEY = "app_console_logs";
const MAX_LOGS = 250;

function storeLog(type, args) {
  try {
    const logs = JSON.parse(localStorage.getItem(LOG_STORAGE_KEY) || "[]");
    logs.unshift({
      type,
      args: Array.from(args),
      timestamp: new Date().toISOString(),
    });
    // Keep only the most recent MAX_LOGS
    if (logs.length > MAX_LOGS) {
      logs.length = MAX_LOGS;
    }
    localStorage.setItem(LOG_STORAGE_KEY, JSON.stringify(logs));
  }
  catch (err) {
    //do nothing
  }
}

export function overrideConsole() {
  ["log", "info", "warn", "error", "debug"].forEach((type) => {
    // const original = console[type];
    console[type] = function (...args) {
      storeLog(type, args);
      // original.apply(console, args);
    };
  });
}